/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { computed, inject, Injectable } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import {
  CenterUserDto,
  CenterUserService,
  UserService,
} from '@malirang/api-client';
import { BaseStore } from '@malirang/front-share';
import { lastValueFrom } from 'rxjs';
import { UserStore } from '../user.store';
import { CenterStore } from './center.store';
import { Capacitor } from '@capacitor/core';
import {
  ActionPerformed,
  PushNotifications,
  Token,
} from '@capacitor/push-notifications';

type State = {
  centerUser: CenterUserDto | null;
};

@Injectable({ providedIn: 'root' })
export class CenterUserStore extends BaseStore<State> {
  private readonly centerUserService = inject(CenterUserService);
  private readonly userStore = inject(UserStore);
  private readonly centerStore = inject(CenterStore);
  private readonly userService = inject(UserService);

  currentCenterUser = computed(() => this.state()?.centerUser);
  currentCenterUser$ = toObservable(this.currentCenterUser);

  myColor = computed(() => this.currentCenterUser()?.color);

  constructor() {
    super({
      centerUser: null,
    });
  }

  async fetchCenterUser() {
    const centerId = this.centerStore.currentCenter()?.id;
    const userId = this.userStore.user()?.id;

    if (!centerId || !userId) return;

    const res = await lastValueFrom(
      this.centerUserService.centerUserControllerFindByUserIdAndCenterId({
        centerId,
        userId,
      }),
    );
    this.saveToken();
    this.setCenterUser(res);
  }

  setCenterUser(centerUser: CenterUserDto) {
    this.updateState({ centerUser });
  }

  /**
   * @name saveToken
   * @description 푸시 알림을 위한 토큰을 저장합니다.
   * @returns {Promise<void>}
   */
  async saveToken(): Promise<void> {
    setTimeout(async () => {
      if (!this.userStore.user()) return;
      if (!Capacitor.isNativePlatform()) return;

      try {
        const result = await PushNotifications.requestPermissions();
        if (result.receive === 'granted') {
          await PushNotifications.register();
          PushNotifications.addListener(
            'registration',
            async (token: Token) => {
              if (!this.userStore.user()?.fcmTokens?.includes(token.value)) {
                try {
                  this.userService
                    .patchUserControllerUpdateFirebaseToken({
                      token: token.value,
                    })
                    .subscribe({
                      next: () => {
                        console.debug('Firebase updated successfully');
                      },
                      error: (error) => {
                        console.error('Error updating Firebase token', error);
                      },
                    });
                } catch (err) {
                  console.error('Error updating Firebase token', err);
                }
              }
            },
          );

          PushNotifications.addListener('registrationError', (error: any) => {
            console.error('Registration error:', error);
          });

          PushNotifications.addListener(
            'pushNotificationActionPerformed',
            (notification: ActionPerformed) => {},
          );
        } else {
          console.error('Push notification permission not granted');
        }
      } catch (error) {
        console.error('Error requesting push notification permissions', error);
      }
    }, 3000);
  }
}
